import React from 'react';
import { FilterCase } from 'dash-table/components/Table/props';
export default ({ filterOptions, toggleFilterOptions }) => (React.createElement("input", { type: 'button', className: `dash-filter--case ${filterOptions.case === FilterCase.Sensitive
        ? 'dash-filter--case--sensitive'
        : 'dash-filter--case--insensitive'}`, onClick: toggleFilterOptions, title: 'Toggle filter case sensitivity', value: 'Aa' }));
